import { connect } from "react-redux";
import { Modal, message } from "antd";
import React, { Component } from "react";

import { fetchAllSlides, addSlide, deleteSlide } from "../../actions/Slideshow";
import SlideModal from "./SlideshowsModal";

const $ = window.$;

class Slideshow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      uploadImages: undefined,
    };
  }

  componentDidMount() {
    // $(function () {
    //     $('[data-toggle="tooltip"]').tooltip();
    // });
    this.props.fetchAllSlides();
  }

  onAddClick() {
    this.setState({ showModal: true });
  }

  onModalCancel() {
    this.setState({
      showModal: false,
      uploadImages: undefined,
      uploadImages: undefined,
    });
  }

  onImageChange(file) {
    this.setState({ uploadImages: file });
  }

  onModalSubmit() {
    this.setState({ showModal: false });
    const hideLoading = message.loading("Uploading Image...", 0);
    console.log("onModalSubmit", this.state.uploadImages);
    const file = this.state.uploadImages;
    this.props.addSlide(
      file,
      (uploadingFile, progress) => {
        // image upload progress
      },
      (error) => {
        hideLoading();
        if (error) {
          message.error("Error saving Banner!");
        } else {
          message.success("Banner has been saved!");
          //   history.push('/products');
        }
      }
    );
  }

  onDeleteBanner(id) {
    console.log("onDeleteBanner", id);
    this.props.deleteSlide(id, (success) => {
      console.log("deleteSlide", success);
    });
  }

  renderSlides() {
    const { sortedSlides } = this.props;

    const rows = (sortedSlides || []).map((slide, index) => {
      console.log(slide);
      return (
        <div className="order" key={slide.slideId}>
          <div className="row">
            <div
              className="col-md-auto"
              style={{ textAlign: "right", paddingTop: 8 }}
            >
              <label>{`Order ${index + 1}`}</label>
            </div>
            <div className="col-md-auto product-img">
              <img src={slide.image_paths} alt="Product" />
            </div>
            <div className="col" />
            <div className="col-md-auto">
              <button
                type="button"
                className="btn btn-tooltip"
                data-toggle="tooltip"
                data-placement="top"
                title="Delete"
                onClick={() => this.onDeleteBanner(slide.slideId)}
              >
                <img src="/resources/img/ic-delete.png" alt="delete" />
              </button>
            </div>
          </div>
        </div>
      );
    });

    return <div className="order-list">{rows}</div>;
  }

  render() {
    const { showModal } = this.state;

    return (
      <div className="main-content">
        <div className="page-title">Slideshow</div>
        <div className="divider" />
        {this.renderSlides()}
        <div
          className="form-group add-more-btn"
          onClick={() => this.onAddClick()}
        >
          <img src="/resources/img/ic-add.png" alt="" />
          <label>Add Slide</label>
        </div>
        <Modal visible={showModal} closable={false} footer={null}>
          <SlideModal
            onCancel={this.onModalCancel.bind(this)}
            onAdd={this.onModalSubmit.bind(this)}
            onFileChange={this.onImageChange.bind(this)}
            value={this.state.uploadImages}
          />
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { isSlideLoading, sortedSlides, slides } = state.slides;
  return { isSlideLoading, sortedSlides, slides };
}

export default connect(
  mapStateToProps,
  {
    fetchAllSlides,
    addSlide,
    deleteSlide,
  }
)(Slideshow);



// WEBPACK FOOTER //
// ./src/views/slideshow/index.js